import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Center.styles";
/**
 * Контейнер для вертикального центрирования. В компонент можно передавать
 * свойства как в любой *div* (кроме `className`)
 */

export var Center = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Center, _React$Component);

  function Center() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.renderMain = function (props) {
      var _cx;

      var align = props.align,
          rest = _objectWithoutPropertiesLoose(props, ["align"]);

      return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
        className: cx((_cx = {}, _cx[styles.root()] = true, _cx[styles.rootAlignLeft()] = align === 'left', _cx[styles.rootAlignRight()] = align === 'right', _cx))
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.spring()
      }), /*#__PURE__*/React.createElement("span", {
        className: styles.container()
      }, _this.props.children));
    };

    return _this;
  }

  var _proto = Center.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(CommonWrapper, this.props, this.renderMain);
  };

  return Center;
}(React.Component);
Center.__KONTUR_REACT_UI__ = 'Center';
Center.defaultProps = {
  align: 'center'
};